import React from 'react';

/**
 * Sdílená hlavička pro dashboard i jednotlivé sekce.
 * onBack: pokud je zadáno, zobrazí se tlačítko "Zpět" (návrat na výběr sekce).
 * right: volitelný extra obsah vpravo vedle tlačítka Odhlásit (např. počet fotek).
 */
export default function Header({ eyebrow, title, onBack, onLogout, right }) {
  return (
    <header className="header">
      <div className="header__brand">
        {onBack && (
          <button className="header__back" onClick={onBack} type="button">
            ← Zpět
          </button>
        )}
        <span className="header__eyebrow">{eyebrow}</span>
        <h1 className="header__title">{title}</h1>
      </div>
      <div className="header__right">
        {right}
        <button className="btn btn--ghost header__logout" onClick={onLogout} type="button">
          Odhlásit
        </button>
      </div>
    </header>
  );
}
